import * as React from 'react';

import {Box, Typography} from "@mui/material";

import BaBarre from "./BaBarre";
import {formatPercentage, getLabelFromNuance, getNomElection, tours} from "../../../Utils";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";


export default function AnalyseElectionParCandidat({data, total, abstentions, otherResults,couleurPolitique}) {


    return (
        <Box sx={{width: '100%',height:"100%", display: "flex", flexDirection: "column", mb: 2}}>
            {Object.keys(data).sort().reverse().map((key, index) => {
                let maxT1 = total[key].t1;
                let maxT2 = 0;
                if (data[key].t2) {
                    maxT2 = total[key].t2;
                }
                return (<Box key={key} sx={{width: '100%', display: "flex", flexDirection: "column", mb: 1}}>
                    <Box sx={{
                        width: 'calc(100% - 32px)',
                        display: "flex",
                        flexDirection: "column",
                        mb: 2,
                        height: 50,
                        justifyContent: "center",
                        backgroundColor: "#ededed",
                        color: "#707070",
                        pl: 5
                    }}>
                        <Typography
                            sx={{
                                color: "#666",
                                fontSize: "20px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "24px"
                            }}>{key}</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex", flexDirection: "row",
                        width: '100%',
                        justifyContent: "space-around",
                        alignItems: "flex-start",

                    }}>
                        {data[key].t1 && <BaBarre data={data[key].t1} year={key} total2={total[key].t1} total={maxT1}
                                                  abstention={abstentions[key].t1}
                                                  title={tours.t1}
                                                  couleurPolitique={couleurPolitique}
                        />}
                        {data[key].t2 && <BaBarre data={data[key].t2} year={key} total2={total[key].t2} total={maxT2}
                                                  dataT1={data[key].t1} abstention={abstentions[key].t2}
                                                  title={tours.t2}
                                                  couleurPolitique={couleurPolitique}
                        />}
                        {!data[key].t2 &&
                            <Box sx={{display:"flex", flexDirection: "column", width: "100%",height: 240,justifyContent: "center",  }}>
                                <Box sx={{
                                    boxSizing: "border-box",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    padding: 1,
                                    gap: 1,
                                    background: "#FFFFFF",
                                    border: "1px solid #f40a06",
                                    color: "#f40a06",
                                    borderRadius: 2,
                                    height: 50,
                                }}>
                                    <InfoOutlineIcon/>
                                    <Typography variant={"body"} sx={{
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"},

                                        flex: "none",
                                        order: "1",
                                        flexGrow: "1"
                                    }}>
                                        Victoire au Premier tour
                                    </Typography>
                                </Box>
                            </Box>
                        }

                    </Box>
                </Box>)
            })}

        </Box>
    );
}
